import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import './axios/request.js'
import http from './api/http'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';


Vue.config.productionTip = false
Vue.prototype.$http = http

Vue.use(Element)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

